import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

// Register chart components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const LineChartComponent = ({ data }) => {
  const chartData = {
    labels: data.labels,
    datasets: data.datasets.map(dataset => ({
      label: dataset.label,
      data: dataset.data,
      borderColor: dataset.borderColor,
      backgroundColor: 'transparent',
      fill: false,
      tension: 0.4,
      cubicInterpolationMode: 'monotone',
      pointRadius: 5,   
    })),
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: data.title,
        font: {
          size: 20,
          weight: 'bold',
          family: 'Arial',
        },
        color: '#333',
        padding: { top: 20, bottom: 10 },
        align: 'center',
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#FFF',
        bodyColor: '#FFF',
        borderColor: '#FFF',
        borderWidth: 1,
        padding: 10,
      }
    },
    scales: {
        x: {
            title: {
              display: true,
              text: data.xLabel || 'X Axis',
              font: { size: 16, weight: 'bold' },
              color: '#333',
            },
            grid: {
                color: '#ddd',
                lineWidth: 1, 
                borderColor: '#666',
                borderWidth: 2,
            },
            ticks: {
                font: { size: 14, color: '#333' },
            },
        },
        y: {
          title: {
              display: true,
              text: data.yLabel || 'Y Axis',
              font: { size: 16, weight: 'bold' },
              color: '#333',
            },
            grid: {
                color: '#ddd',
                lineWidth: 1,
                borderColor: '#666',
                borderWidth: 2,
            },
            ticks: {
                font: { size: 14, color: '#333' },
                beginAtZero: true,
            },
        },
    },
};


  return (
    <div className='LineChartComponent'>
      <Line data={chartData} options={options} />
    </div>
  );
};

export default LineChartComponent;
